export var SquareSSOFailedEnum;
(function (SquareSSOFailedEnum) {
    SquareSSOFailedEnum["SSO_FS_USER_NOT_FOUND"] = "sso_fs_user_not_found";
})(SquareSSOFailedEnum || (SquareSSOFailedEnum = {}));
//# sourceMappingURL=SquareSSOFailedEnum.js.map